import { useState, memo } from "react";
import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../theme/palette";
import { Text } from "../Base";
import { View } from "../View";
import { PickupPopup } from "./PickupPopup";

const useStyles = makeStyles({
  markerContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "-18px",
    marginLeft: "2px",
    cursor: "pointer",
  },
  container: {
    width: "30px",
    height: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
    padding: "2px",
  },
  textContainer: {
    background: palette.black,
    borderRadius: "4px",
  },
  text: {
    margin: "auto",
    color: "white",
  },
  routesCountContainer: {
    height: "16px",
    width: "16px",
    borderRadius: "100px",
    background: palette.white,
    position: "relative",
    right: "8px",
    top: "12px",
    boxShadow: `-1px 1px 2px 0px ${palette.typography.black.high}`,
  },
  routesCountText: {
    fontSize: "10px",
    margin: "auto",
  },
});

export const PickupLabel = memo(({ pickupConfig }) => {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState();

  const routesCount = Object.keys(pickupConfig.popupLabels).length;

  if (!routesCount) return null;
  return (
    <>
      <View
        className={styles.markerContainer}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <View>
          <Grid container className={styles.routesCountContainer}>
            <Text className={styles.routesCountText}>{routesCount}</Text>
          </Grid>
          <Grid
            container
            className={styles.container}
            role="button"
            aria-pressed={!!anchorEl}
            onClick={(e) => {
              e.stopPropagation();
              setAnchorEl(!anchorEl ? e.currentTarget : null);
            }}
          >
            <Grid container className={styles.textContainer}>
              <Text className={styles.text}>P</Text>
            </Grid>
          </Grid>
        </View>
        <PickupPopup
          anchorEl={anchorEl}
          onClose={() => {
            setAnchorEl(null);
          }}
          pickupConfig={pickupConfig}
        />
      </View>
    </>
  );
});
